<template>
  <div class="beneficios-detalle-container">
    <div class="beneficios-search-container">
      <a-input-search
        class="beneficios-search"
        placeholder="Buscar en detalles..."
        v-model="searchText"
        @change="handleSearch"
      />
    </div>
    <a-spin :spinning="loading">
      <div v-if="beneficioInfo && beneficioInfo.nombre" class="beneficio-header-info">
        <a-avatar
          :size="avatarSize"
          :style="{ backgroundColor: beneficioInfo.iconColor }"
          class="beneficio-icon-detalle"
        >
          <img
            v-if="beneficioInfo.logoUrl"
            :src="beneficioInfo.logoUrl"
            :alt="beneficioInfo.nombre"
            style="width: 100%; height: 100%; object-fit: cover;"
          />
          <span v-else>{{ beneficioInfo.icon }}</span>
        </a-avatar>
        <div class="beneficio-info-text">
          <h2 class="beneficio-tipo">{{ beneficioInfo.nombre }}</h2>
          <a-badge
            :status="beneficioInfo.estado === 'ACTIVO' ? 'success' : 'default'"
            :text="beneficioInfo.estado"
          />
        </div>
      </div>

      <div v-if="detalleDataOrdenado && detalleDataOrdenado.length > 0" class="detalle-content">
        <div class="detalle-section">
          <div class="detalle-list">
            <a-card
              v-for="(detalle, index) in detalleFiltrado"
              :key="detalle.id"
              class="detalle-card"
            >
              <template slot="title">
                <div class="detalle-card-header">
                  <img
                    v-if="detalle.logoUrl"
                    :src="detalle.logoUrl"
                    alt="Logo"
                    class="detalle-card-logo"
                  />
                  <div class="detalle-card-info">
                    <span class="detalle-card-title">{{ detalle.att_car1 || `Detalle ${index + 1}` }}</span>
                    <div v-if="detalle.att_car2" class="detalle-item">
                      <span class="detalle-value">{{ detalle.att_car2 }}</span>
                    </div>
                    <a-badge
                      v-if="detalle.status"
                      :status="detalle.status === 'ACTIVO' ? 'success' : 'default'"
                      :text="detalle.status"
                      class="detalle-status-badge"
                    />
                  </div>
                </div>
              </template>
              <div v-if="detalle.description" class="detalle-item">
                <span class="detalle-value">{{ detalle.description }}</span>
              </div>

              <!--<div v-if="detalle.att_car2" class="detalle-item">
                <span class="detalle-value">{{ detalle.att_car2 }}</span>
              </div>-->

              <div v-if="detalle.att_num1 !== null && detalle.att_num1 !== undefined" class="detalle-item">
                <span class="detalle-value">{{ detalle.att_num1 }}</span>
              </div>

              <div v-if="detalle.att_num2 !== null && detalle.att_num2 !== undefined" class="detalle-item">
                <span class="detalle-value">{{ detalle.att_num2 }}</span>
              </div>

              <div v-if="detalle.att_date1" class="detalle-item">
                <span class="detalle-value">{{ formatearFecha(detalle.att_date1) }}</span>
              </div>

              <div v-if="detalle.att_date2" class="detalle-item">
                <span class="detalle-value">{{ formatearFecha(detalle.att_date2) }}</span>
              </div>

              <div class="beneficio-actions">
                <a-button
                  v-if="detalle.url"
                  type="link"
                  @click="abrirUrl(detalle.url)"
                >
                  {{ detalle.url }}
                </a-button>
              </div>

            </a-card>
          </div>
        </div>
      </div>
      <a-empty
        v-else-if="!loading"
        description="No se encontraron detalles para este beneficio"
      />
    </a-spin>
  </div>
</template>

<script>
  import HttpUtil from '@/util/HttpUtil'

  export default {
    name: 'BeneficiosDetalle',
    props: {
      beneficioId: {
        type: Number,
        required: true
      },
      beneficioInfo: {
        type: Object,
        required: false,
        default: () => ({})
      }
    },
    data () {
      return {
        loading: false,
        detalleData: [],
        httpClient: null,
        searchText: ''
      }
    },
    computed: {
      avatarSize () {
        if (typeof window === 'undefined') {
          return 64
        }
        const windowWidth = window.innerWidth
        if (windowWidth <= 480) {
          return 40
        } else if (windowWidth <= 768) {
          return 48
        }
        return 64
      },
      detalleDataOrdenado () {
        if (!this.detalleData || this.detalleData.length === 0) {
          return []
        }
        return [...this.detalleData].sort((a, b) => {
          const att1A = a.att_car1
          const att1B = b.att_car1

          // Si ambos son null/vacío, mantener orden original
          if (!att1A && !att1B) {
            return 0
          }
          // Si solo A es null/vacío, B va primero
          if (!att1A) {
            return 1
          }
          // Si solo B es null/vacío, A va primero
          if (!att1B) {
            return -1
          }
          // Si ambos tienen valor, ordenar alfabéticamente
          return att1A.toString().toLowerCase().localeCompare(att1B.toString().toLowerCase())
        })
      },
      detalleFiltrado () {
        let data = this.detalleDataOrdenado

        // Filtrar siempre por activos
        data = data.filter(detalle => detalle.status === 'ACTIVO')

        if (!this.searchText.trim()) {
          return data
        }
        const searchTerm = this.searchText.toLowerCase().trim()
        return data.filter(detalle => {
          return (
            (detalle.att_car1 && detalle.att_car1.toLowerCase().includes(searchTerm)) ||
            (detalle.att_car2 && detalle.att_car2.toLowerCase().includes(searchTerm)) ||
            (detalle.description && detalle.description.toLowerCase().includes(searchTerm)) ||
            (detalle.att_num1 && detalle.att_num1.toString().includes(searchTerm)) ||
            (detalle.att_num2 && detalle.att_num2.toString().includes(searchTerm)) ||
            (detalle.url && detalle.url.toLowerCase().includes(searchTerm))
          )
        })
      }
    },
    watch: {
      beneficioId: {
        immediate: true,
        handler (newId, oldId) {
          if (newId && newId !== oldId) {
            this.cargarDetalle()
          }
        }
      }
    },
    created () {
      this.httpClient = new HttpUtil('benefits_cat_detail')
    },
    methods: {
      cargarDetalle () {
        if (!this.httpClient) {
          this.httpClient = new HttpUtil('benefits_cat_detail')
        }

        this.loading = true
        this.detalleData = []

        this.httpClient.get(
          {id_benefits: this.beneficioId},
          this.manejaRespuestaCarga,
          this.manejaErrorCarga
        ).catch(error => {
          console.error('Error no capturado en cargarDetalle:', error)
          this.manejaErrorCarga(error)
        })
      },
      manejaRespuestaCarga (response) {
        this.loading = false

        const detalleData = Array.isArray(response.data) ? response.data : response.data.data

        if (detalleData && detalleData.length > 0) {
          this.detalleData = detalleData.map(this.mapearDetalle)
        } else {
          this.$message.warning('No se encontraron detalles para este beneficio')
        }
      },
      manejaErrorCarga (error) {
        this.loading = false
        const errorMessage = (error.response && error.response.data && error.response.data.message) || 'Error al cargar detalle del beneficio'
        this.$message.error(errorMessage)
      },
      mapearDetalle (detalleBackend) {
        const logoData = detalleBackend.logo_base64 ||
          detalleBackend.logo ||
          detalleBackend.logo_path ||
          detalleBackend.logo_url ||
          null

        return {
          id: detalleBackend.id,
          id_benefits: detalleBackend.id_benefits,
          description: detalleBackend.description || '',
          logo: detalleBackend.logo,
          logoUrl: this.procesarLogoUrl(logoData),
          status: detalleBackend.status || 'ACTIVO',
          att_car1: detalleBackend.att_car1,
          att_car2: detalleBackend.att_car2,
          att_num1: detalleBackend.att_num1,
          att_num2: detalleBackend.att_num2,
          att_date1: detalleBackend.att_date1,
          att_date2: detalleBackend.att_date2,
          created_by: detalleBackend.created_by,
          created_on: detalleBackend.created_on,
          modified_by: detalleBackend.modified_by,
          modified_on: detalleBackend.modified_on,
          url: detalleBackend.url
        }
      },
      procesarLogoUrl (logoData) {
        if (!logoData) {
          return null
        }

        if (typeof logoData === 'string' && (logoData.startsWith('http://') || logoData.startsWith('https://'))) {
          return logoData
        }

        if (typeof logoData === 'string' && logoData.startsWith('data:')) {
          return logoData
        }

        if (typeof logoData === 'string' && logoData.startsWith('/')) {
          return this.$store.state.appSettings.apiurl + logoData
        }

        if (typeof logoData === 'string' && logoData.length > 0) {
          const imageFormat = this.detectImageFormat(logoData)
          return `data:image/${imageFormat};base64,${logoData}`
        }

        return null
      },
      detectImageFormat (base64String) {
        if (!base64String || base64String.length < 10) {
          return 'png'
        }

        const header = base64String.substring(0, 10).toUpperCase()

        if (header.startsWith('IVBORW')) return 'png'
        if (header.startsWith('/9J/')) return 'jpeg'
        if (header.startsWith('R0LGOD')) return 'gif'
        if (header.startsWith('UKLGR')) return 'webp'

        return 'png'
      },
      formatearFecha (dateString) {
        if (!dateString) return ''

        try {
          const date = new Date(dateString)
          return date.toLocaleDateString('es-ES', {
            year: 'numeric',
            month: 'long',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
          })
        } catch (error) {
          return dateString
        }
      },
      abrirUrl (url) {
        if (url) {
          window.open(url, '_blank')
        } else {
          this.$message.warning('Este beneficio no tiene URL configurada')
        }
      },
      handleSearch () {
        // El método vacío es suficiente ya que el computed property se actualiza automáticamente
      }
    }
  }
</script>

<style scoped>
  .beneficios-search-container {
    margin-bottom: 16px;
    padding: 0 8px;
  }

  .beneficios-search {
    width: 100%;
    max-width: 400px;
    margin-bottom: 16px;
  }

  .beneficios-detalle-container {
    padding: 0;
    min-height: 400px;
    width: 100%;
    max-width: 100%;
    overflow-x: hidden;
    box-sizing: border-box;
  }

  .beneficio-header-info {
    display: flex;
    align-items: center;
    gap: 16px;
    padding: 24px;
    background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
    border-radius: 12px;
    margin-bottom: 24px;
    border: 1px solid #e5e7eb;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  .beneficio-icon-detalle {
    flex-shrink: 0;
    font-size: 28px;
    font-weight: bold;
    color: white;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .beneficio-icon-detalle img {
    border-radius: 50%;
  }

  .beneficio-info-text {
    flex: 1;
    min-width: 0;
    overflow: hidden;
  }

  .beneficio-tipo {
    margin: 0 0 8px 0;
    font-size: 24px;
    font-weight: 700;
    color: #262626;
    line-height: 1.3;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .detalle-content {
    display: flex;
    flex-direction: column;
    gap: 24px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  .detalle-section {
    margin-bottom: 16px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  .detalle-list {
    display: flex;
    flex-direction: column;
    gap: 16px;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  .detalle-card {
    border-radius: 8px;
    border: 1px solid #e5e7eb;
    width: 100%;
    max-width: 100%;
    box-sizing: border-box;
  }

  .detalle-card-header {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .detalle-card-logo {
    width: 100px;
    height: 100px;
    object-fit: contain;
    border-radius: 4px;
    border: 1px solid #e5e7eb;
    padding: 4px;
    background: #fafafa;
    flex-shrink: 0;
  }

  .detalle-card-info {
    display: flex;
    flex-direction: column;
    gap: 4px;
    flex: 1;
    min-width: 0;
  }

  .detalle-card-title {
    font-size: 18px;
    font-weight: 600;
    color: #262626;
  }

  .detalle-status-badge {
    font-size: 12px;
  }

  .detalle-item {
    margin-bottom: 16px;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  .detalle-item:last-child {
    margin-bottom: 0;
  }

  .detalle-label {
    display: block;
    font-weight: 600;
    color: #262626;
    margin-bottom: 4px;
    font-size: 14px;
  }

  .detalle-value {
    display: block;
    color: #595959;
    line-height: 1.6;
    font-size: 14px;
    margin: 0;
    word-wrap: break-word;
    overflow-wrap: break-word;
    white-space: pre-line;
  }

  .detalle-logo {
    max-width: 200px;
    max-height: 150px;
    object-fit: contain;
    border-radius: 4px;
    border: 1px solid #e5e7eb;
    padding: 8px;
    background: #fafafa;
  }

  .detalle-metadata {
    margin-top: 20px;
    padding-top: 16px;
    border-top: 1px solid #f0f0f0;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
    gap: 12px;
  }

  .detalle-item-small {
    display: flex;
    flex-direction: column;
  }

  .detalle-label-small {
    font-size: 12px;
    color: #8c8c8c;
    font-weight: 500;
    margin-bottom: 2px;
  }

  .detalle-value-small {
    font-size: 13px;
    color: #595959;
    word-wrap: break-word;
    overflow-wrap: break-word;
  }

  @media (max-width: 768px) {
    .beneficios-detalle-container {
      padding: 0;
      overflow-x: hidden;
    }

    .beneficio-header-info {
      flex-direction: row;
      align-items: center;
      padding: 12px;
      gap: 10px;
      margin-bottom: 12px;
      border-radius: 8px;
    }

    .beneficio-icon-detalle {
      font-size: 18px;
    }

    .beneficio-tipo {
      font-size: 16px;
      line-height: 1.4;
      margin: 0 0 4px 0;
    }

    .beneficio-info-text >>> .ant-badge {
      font-size: 11px;
    }

    .detalle-content {
      gap: 12px;
    }

    .detalle-list {
      gap: 10px;
    }

    .detalle-card {
      margin-bottom: 0;
      border-radius: 6px;
    }

    .detalle-card-header {
      gap: 8px;
    }

    .detalle-card-logo {
      width: 32px;
      height: 32px;
      padding: 3px;
    }

    .detalle-card-info {
      gap: 3px;
    }

    .detalle-card-title {
      font-size: 13px;
    }

    .detalle-status-badge {
      font-size: 11px;
    }

    .detalle-item {
      margin-bottom: 10px;
    }

    .detalle-label {
      font-size: 12px;
      margin-bottom: 2px;
    }

    .detalle-value {
      font-size: 12px;
      line-height: 1.5;
    }

    .detalle-logo {
      max-width: 100%;
      max-height: 150px;
      padding: 6px;
    }

    .detalle-metadata {
      grid-template-columns: 1fr;
      gap: 6px;
      margin-top: 12px;
      padding-top: 10px;
    }

    .detalle-label-small {
      font-size: 11px;
    }

    .detalle-value-small {
      font-size: 11px;
    }
  }

  @media (max-width: 480px) {
    .beneficio-header-info {
      padding: 10px;
      gap: 8px;
      margin-bottom: 10px;
    }

    .beneficio-icon-detalle {
      font-size: 16px;
    }

    .beneficio-tipo {
      font-size: 14px;
      line-height: 1.3;
    }

    .beneficio-info-text >>> .ant-badge {
      font-size: 10px;
    }

    .beneficio-info-text >>> .ant-badge-status-text {
      font-size: 10px;
    }

    .detalle-content {
      gap: 10px;
    }

    .detalle-list {
      gap: 8px;
    }

    .detalle-card-header {
      gap: 6px;
    }

    .detalle-card-logo {
      width: 28px;
      height: 28px;
      padding: 2px;
    }

    .detalle-card-info {
      gap: 2px;
    }

    .detalle-card-title {
      font-size: 12px;
    }

    .detalle-status-badge {
      font-size: 10px;
    }

    .detalle-item {
      margin-bottom: 8px;
    }

    .detalle-label {
      font-size: 11px;
      margin-bottom: 2px;
    }

    .detalle-value {
      font-size: 11px;
      line-height: 1.4;
    }

    .detalle-logo {
      max-width: 100%;
      max-height: 120px;
      padding: 4px;
    }

    .detalle-metadata {
      margin-top: 10px;
      padding-top: 8px;
      gap: 4px;
    }

    .detalle-label-small {
      font-size: 10px;
    }

    .detalle-value-small {
      font-size: 10px;
    }
  }

  /* Estilos adicionales para los cards de Ant Design en móviles */
  @media (max-width: 768px) {
    .detalle-card >>> .ant-card-head {
      padding: 10px 12px;
      min-height: auto;
    }

    .detalle-card >>> .ant-card-head-title {
      padding: 0;
      font-size: 13px;
      font-weight: 600;
    }

    .detalle-card >>> .ant-card-body {
      padding: 12px;
    }
  }

  @media (max-width: 480px) {
    .detalle-card >>> .ant-card-head {
      padding: 8px 10px;
    }

    .detalle-card >>> .ant-card-head-title {
      font-size: 12px;
    }

    .detalle-card >>> .ant-card-body {
      padding: 10px;
    }
  }
</style>


// WEBPACK FOOTER //
// src/customization/SelfService/pages/Dashboard/BeneficiosDetalle.vue